"use strict";

exports.__esModule = true;
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _clsx = _interopRequireDefault(require("clsx"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
/**
 * The ProgressBar component provides visual feedback on the progress of an activity.
 */
const ProgressBar = _ref => {
  let {
    amount,
    min,
    max,
    offset,
    ticks = [],
    displayEdgesValue,
    className,
    ...attributes
  } = _ref;
  const range = max - min;
  const percentage = (amount - min) * 100 / range;
  const offsetPercentage = (offset - min) * 100 / range;
  const amountValue = {
    width: Math.min(Math.max(percentage, 0), 100) + "%",
    marginLeft: offsetPercentage + "%"
  };
  return /*#__PURE__*/_react.default.createElement("div", _extends({
    className: (0, _clsx.default)('uk-progress-bar', className),
    role: "progressbar",
    tabIndex: "0",
    "aria-valuenow": amount,
    "aria-valuemin": min,
    "aria-valuemax": max
  }, attributes), /*#__PURE__*/_react.default.createElement("div", {
    className: "uk-progress-meter",
    style: amountValue
  }), ticks && ticks.length > 0 && /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _clsx.default)('uk-progress-ticks', !displayEdgesValue && 'uk-progress-ticks--no-edge')
  }, ticks.map((t, i) => /*#__PURE__*/_react.default.createElement("div", {
    key: i,
    className: "uk-progress-ticks__tick",
    "data-tick": t
  }))));
};
ProgressBar.propTypes = {
  /**
   * Current value of the ProgressBar, should be between low and high values.
   */
  amount: _propTypes.default.number,
  /**
   * Current value of the ProgressBar, should be between low and high values.
   */
  offset: _propTypes.default.number,
  /**
   * Minimum value, represents the progressBar at 0%.
   */
  min: _propTypes.default.number,
  /**
   * Maximum value, represents the progressBar at 100%.
   */
  max: _propTypes.default.number,
  ticks: _propTypes.default.arrayOf(_propTypes.default.number),
  displayEdgesValue: _propTypes.default.bool
};
ProgressBar.defaultProps = {
  amount: 0,
  offset: 0,
  min: 0,
  max: 100,
  displayEdgesValue: false
};
var _default = exports.default = ProgressBar;